//#region Used in Offline Mode Interface

export interface INovaEcommHandler {
  Meta_DoesLocalStorageExist(StoreHandle: string): boolean;
  Meta_CreateLocalStorage(Key: string, Value: ManikEcomm_LocalDB): boolean;
  Meta_AppMetaDataSynch(StoreHandle: string);
  Meta_AppMasterDataSynch(StoreHandle: string);
}

export class ManikEcomm_LocalDB {
  ManikErrorLibrary: IManikErrorLibrary[];
  SplKeyHandler: ISplKeyHandler[];
  StoreInfo: IStoreInfo;
  Branches: IBranches[];
  Txn_TabUserContext: Txn_TabUserContext[];
  Txn_CartMaster: Txn_CartMaster[];
  Txn_CartItems: Txn_CartItems[];
  Categories: ICategories[];
  BranchDetails: IBranch[];
  Products: IProducts[];
  Txn_CurrentDeviceContext: ITxn_CurrentDeviceContext;
  Tabs: ITabs[];
}

export interface IAppMetaData {
  ManikJSon:
  [
    {
      JSon0: IEntityMetaDataCollection[],
      JSon1: IManikErrorLibrary[],
      JSon2: ISplKeyHandler[],
      JSon3: IStoreInfo[],
      JSon4: IBranches[],
      JSon5: Txn_TabUserContext[],
      JSon6: Txn_CartMaster[],
      JSon7: Txn_CartItems[]
    }
  ]
}

export interface IAppMasterData {
  ManikJSon:
  [
    {
      JSon0: IEntityMetaDataCollection[],
      JSon1: IBranch[],
      JSon2: IShifts[],
      JSon3: ISalesPersons[],
      JSon4: Txn_TabUserContext[],
      JSon5: ICategories[],
      JSon6: ISubCategories[],
      JSon7: IProducts[]
    }
  ]
}

//#endregion

//#region Used in OnLine Mode Interface

export interface IMyStore {
  ManikJSon:
  [
    {
      JSon0: IStoreInfo[],
      JSon1: IBranches[]
    }
  ]
}

export interface IECommModel {
  ManikJSon:
  [
    {
      JSon0: ITxn_CurrentDeviceContext[],
      JSon1: Txn_TabUserContext[],
      JSon2: Txn_CartMaster[],
      JSon3: Txn_CartItems[]
    }
  ]
}

export interface IMasterData {

}
//#endregion

export interface IEntityMetaDataCollection {
  Entity: string;
  EntityIndex: number;
  MinRecordCount: number;
}

export interface IManikErrorLibrary {
  MessageCode: string;
  Message: string;
}

export interface ISplKeyHandler {
  SplKeyCode: string;
  KeyCodeMeaning: string;
}

export interface IStoreInfo {
  StoreID: number;
  StoreHandle: string;
  BusinessID: number;
  StoreName: string;
  StoreTagline: string;
  AcceptOrdersOnlyDuringBusinessHours: string;
  MinimumOrderAmount: number;
  TandC: string;
  OrderResponseTimeFrame: string;
  SpecialityStatement: string;
  StoreClosedStatement: string;
  SupportContactPerson: string;
  SupportEmail: string;
  SupportPhone: number;
  DeliveryAreaText: string;
  DeliverySlotsText: string;
  ShowCitySelection: string;
  ShowLocalitySelection: string;
  SMSVerificationOnRegistration: string;
  OrderCancellationTimeWindow: number;
  CurrencySymbol: string;
  CartPersistenceDurationInHrs: string;
  IsHyperLocal: string;
  AllowForeignCustomerAddress: string;
  Latitude: number;
  Longitude: number;
  CatalogVersion: number;
  IsSmallShop: string;
  ArePOSTabsPredefined: string;
}

export interface IBranches {
  StoreBranchID: number;
  BranchHandle: string;
  BranchName: string;
  BranchAddress: string;
  EmailID: string;
  PhoneNumber: number;
  PhoneNumber2: number;
  ContactPerson: string;
  WorkHours: number;
  Latitude: number;
  Longitude: number;
  SpecialNotes: string;
  DisplayOrder: number;
  AcceptOrdersOnlyDuringBusinessHours: string;
  AcceptingOrdersNow_Online: string;
  AcceptingOrdersNow_POS: string;
  AcceptingOrdersNow_App: string;
  AcceptingOrdersNow_Marketplace: string;
  AcceptingOrdersNow_BizSpot: string;
}

export class Txn_TabUserContext {
  TabHandle?: string;
  TabName?: string;
  BranchTabID?: number;
  BranchHandle?: string;
  DOW?: string;
  SalesPersonHandle?: string;
  UserLatitude?: number;
  UserLongitude?: number;
  BuyerHandle?: string;
  BuyerName?: string;
  BuyerMobile?: number;
  BuyerEmail?: string;
  AddlBuyerInfo?: string;
  LanguageID?: number;
  IsMember?: string;
  SearchText?: string;
  CategoryCSV?: string;
  SubCategoryCSV?: string;
  PriceRangeCSV?: string;
  DiscountPercentCSV?: string;
  NewArrivals?: string;
  InStock?: string;
  BrandCSV?: string;
  CustomerRatingCSV?: string;
  NatureCSV?: string;
  TagsCSV?: string;
  SortByColumnsCSV?: string;
  SortOrderCSV?: string;
}

export class Txn_CartMaster {
  BranchHandle?: string;
  TabHandle?: string;
  OnDeviceCartHandle?: string;
  CartMode?: string;
  CurrentCartBatchHandle?: string;
  CustomerRemarks?: string;
  StorePriceListID?: number;
  DiscountCode?: string;
  FirstActivityTimestamp?: string;
  LastActivityTimestamp?: string;
  CartValidUpto?: string;
  CalcFunda?: string;
}

export class Txn_CartItems {
  OnDeviceCartHandle: string = "";
  CartBatchHandle: string = "";
  ProductHandle: string = "";
  ProductName: string = "";
  CombinationName: string = "";
  VariantID: number;
  CombinationValueID: number;
  MRP: number;
  OfferPrice: number;
  MembersOfferPrice: number;
  SplDiscountCode: string = "";
  FinalAppliedPrice: number;
  ImageURL: string = "";
  CalculatedProductName: string = "";
  Quantity: number;
  CustomizationRemark: string = "";
  CustomizationMediaURL: string = "";
  RequestedDeliveryDate: string = "";
  RequestedDeliveryTime: string = "";
  IsTaxInclusive: string = "";
  TaxAmount: number;
  LineTotalOnMRP: number;
  LineDiscount: number;
  LineTotalOnOfferPrice: number;
  LineTotalOnMembersOfferPrice: number;
  LineSplCalculationHandle: number;
  LocalUpdateTimestamp: string = "";
  CalcFunda: string = "";
}

export interface IBranch {
  StoreBranchID: number;
  BranchHandle: string;
  BranchName: string;
  BranchAddress: string;
  EmailID: string;
  PhoneNumber: number;
  PhoneNumber2: number;
  ContactPerson: string;
  WorkHours: number;
  Latitude: number;
  Longitude: number;
  SpecialNotes: string;
  DisplayOrder: number;
  AcceptOrdersOnlyDuringBusinessHours: string;
  AcceptingOrdersNow_Online: string;
  AcceptingOrdersNow_POS: string;
  AcceptingOrdersNow_App: string;
  AcceptingOrdersNow_Marketplace: string;
  AcceptingOrdersNow_BizSpot: string;
  IsDefault: string;
}

export interface ICategories {
  ProdCategoryID: number;
  ProductCategoryHandle: string;
  StoreID: number;
  StoreBranchID: number;
  ProductCategory: string;
  ParentProductCategoryID: number;
  DisplayOrder: number;
  AcceptOrdersBeyondBusinessHours: string;
  OrderStartTime: string;
  OrderEndTime: string;
}

export interface ISubCategories {

}

export interface IProducts {
  StoreBranchID: number;
  ProductHandle: string;
  MEDIAURL: string;
  CategoryID: number;
  ProductCode: string;
  ProductName: string;
  ProductDescription: string;
  CatchyHeader: string;
  PriceTag: string;
  MRP: number;
  OfferPrice: number;
  MembersOfferPrice: number;
  DiscountTypeID: number;
  DiscountValue: string;
  IsNewArrival: string;
  HomeDeliverable: string;
  RequiresShipping: string;
  DeliveryRestrictions: string;
  ShowOnline: string;
  ShowOnApp: string;
  ShowOnPOS: string;
  AcceptOrdersWhenOutOfStock: string;
  AllowCustomizationRemarks: string;
}

export interface ISalesPersons {
  BranchSalesPersonID: number;
  SalesPersonName: string;
  Designation: string;
  ImageURL: string;
  Remarks: string;
}

export interface IShifts {
  StoreShiftID: number;
  EasyDescription: string;
}

export interface ITxn_CurrentDeviceContext {
  SelectedStoreHandle: string;
  SelectedBranchHandle: string;
  SelectedTabHandle: string;
  LoggedInSalesPersonHandle: string;
  BranchName: string;
}

export interface ITabs {
  BranchTabID: number;
  TabIdentifier: string;
  TabName: string;
}

export interface IStartCheckout {
  ManikJSon: [{ JSon0: [{ ActiveSessionHandle: string; }] }]
}

export interface ISiteMetaData {
  FaviconURL: string;
  Title: string;
  Description: string;
  Keywords: string;
  CategoryName: string;
  BID: number;
  EBID: string;
  CID: number;
  SCID: number;
  SubCategoryName: string;
  BizHandle: string;
  StoreHandle: string;
  SITECSS: string;
  SITEJS: string;
  EDITCSS: string;
  EDITJS: string;
  BIZCSS: string;
  GoogleAnalyticsCode: string;
  BizLatitude: number
  BizLongitude: number;
  PC: string;
  BackendURL: string;
  PDS: string;
  COUNTRYID: number;
  EC: string;
  EOLVIEW: string;
  PageHTML: string;
  ECommServer: string;
}

export interface IMasterCart {
  CartSummary: ICartSummary;
  CartItems: Txn_CartItems[];
}

export interface ICartSummary {
  StoreHandle: string;
  BuyerHandle: string;
  SalesPersonHandle: string;
  TabHandle: string;
  OnDeviceCartHandle: string;
  DeliveryAddressID: string;
  StorePriceListID: string;
  CouponCode: string;
  CalcFunda: string;
  TotProducts: number;
  TotItems: number;
  TotValue: number;
  TotSavings: number;
  Latitude: number;
  Longitude: number;
  ExpirationDate: string;
  LastUpdateSourceID: string;
}